import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { isSimpleView } from 'App/Navigation/utils';
import { HomePage, homePageRouteResolver } from 'Router/homePageRoute';
import { IsAvailable } from 'Router/ReactRoute';

export function checkHomeAvailability(props: IsAvailable<{}>): boolean {
	return (
		homePageRouteResolver(props.userContext, props.workspaceConfiguration) ===
			HomePage.Home &&
		(shouldDisplayHomeTab(props.workspaceConfiguration) ||
			isSimpleView(props.resourceContext.resources))
	);
}

function shouldDisplayHomeTab(workspaceConfiguration: WorkspaceConfiguration): boolean {
	const flagValue = workspaceConfiguration.userInterface.enableWorkspaceHome;
	return flagValue ? flagValue === 'true' : true;
}
